import type {MicrositeRouteDefinition, MicrositeRoutePath} from './types';
import type {LanguageId} from '../translations/utils/languageManifest';

export const resolveLocalizedMicrositePath = (_languageId: LanguageId, routePath: MicrositeRoutePath) => routePath;

export const buildLocalizedMicrositeHref = (route: MicrositeRouteDefinition, languageId: LanguageId) => {
  const localizedPath = route.paths[languageId as keyof typeof route.paths];

  if (!localizedPath) {
    throw new Error(`Missing localized path for route "${route.id}" and locale "${languageId}".`);
  }

  return localizedPath;
};
